<template lang="pug">
v-dialog(:value="false", persistent, scrollable, max-width="900")
  Welcome(v-if="!welcomePassed", @next="welcomePassed = true")

  v-card(v-else)
    v-card-title.headline Onboarding
    v-progress-linear(:value="progress")
    v-card-text.pa-2
      //- Quiz(
      //-   v-if="false",
      //-   :questions="questions",
      //-   @change-step="changeStep",
      //-   @answer="changeAnswers"
      //- )
      QuizCore(
        :questions="questions",
        :step="step",
        :flow-id="userflow.ID",
        :case-id="usercase.ID",
        @answer="changeAnswers",
        @loader="setLoader",
        @set-memory="setMemory",
        @starting="welcomePassed = false",
        @finish="finish"
      )
</template>

<script>
import { questions } from "@/data/globalQuestions.js";
import differenceInMonths from "date-fns/differenceInMonths";

import Quiz from "@/components/Quiz/index.vue";
import QuizCore from "@/components/Quiz/QuizCore.vue";
import Welcome from "./Welcome";

export default {
  components: {
    Quiz,
    QuizCore,
    Welcome,
  },

  data: () => ({
    company: {},
    finishCreation: false,
    welcomePassed: false,
    answers: {},
    isLoader: false,
    dialog: false,
  }),

  mounted() {
    this.dialog = !!(
      this.userflow &&
      this.userflow.status === "in progress" &&
      this.userflowCompany.status !== "in progress" &&
      this.usercase
    );
  },

  methods: {
    finish() {
      this.$store.dispatch("getFlows");
    },

    getPeriodOfTrading(endDate) {
      const diff = Math.abs(differenceInMonths(new Date(), new Date(endDate)));
      if (diff <= 6) return "0 to 6 months";
      if (diff <= 12) return "Over 6 to 12 months";
      if (diff <= 18) return "Over 12 to 18 months";
      if (diff <= 36) return "Over 18 to 36 months";
      if (diff > 36) return "Over 36 months+";
      return null;
    },

    changeAnswers(value) {
      this.answers = value;
    },

    setLoader(payload) {
      this.isLoader = payload ?? false;
    },

    setMemory(payload) {
      const question = this.questions.find((q) => q.index === payload.index);
      if (question) question.chachedValue = payload.input;
    },
  },

  computed: {
    usercase() {
      return this.$store.getters.case;
    },

    userflow() {
      return this.$store.getters.freeCase;
    },

    userflowCompany() {
      return this.$store.getters.freeCompany;
    },

    flow() {
      return this.userflow?.flow;
    },

    step() {
      return this.userflow?.step?.index;
    },

    questions() {
      return questions;
    },

    progress() {
      return this.step && this.questions.length > 0
        ? (this.step / this.questions.length) * 100
        : 0;
    },
  },
};
</script>